import {Button, Flex} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDown, faAngleRight, faCode, faFileLines, faReceipt, faSquare} from "@fortawesome/free-solid-svg-icons";
import React from "react";

import {DraftComponent, DraftElement, DraftElementItem} from "../../../../../../../../feature/Draft";

export const ElementItem = (
    props: {
        element: DraftElement,
        active?: boolean,
        onElementSelected?: (element: DraftElement) => void,
        fullFilled?: boolean,
        children?: React.ReactNode,
        onExpand?: (component: DraftElement) => void,
        expanded?: boolean,
        showEmbeddingState?: boolean,
    }
) => {

    return (
        <Flex
            vertical={true}
            gap={10}
            key={`component-${props.element.id}`}>

            <Button
                key={props.element.id}
                style={{
                    textAlign: 'start',
                    height: "auto",
                    background: props.active ? "#f0f0f0" : undefined,
                    padding: '8px 8px 8px 16px'
                }}
                type={'text'}
                onClick={() => {
                    props.onElementSelected?.(props.element)
                }}>
                <Flex
                    style={{width: "100%"}}
                    justify={'space-between'}
                    gap={10}
                    align={'center'}
                >

                    <FontAwesomeIcon
                        style={{color: props.element.title && props.element.description && props.element.title.trim().length > 0 && props.element.description.trim().length > 0 ? "#0958d9" : props.element.title?.trim().length == 0 && props.element.description?.trim().length == 0 ? "#cccccc" : "#faad14"}}
                        icon={faReceipt}/>

                    <div style={{
                        flexGrow: 1,
                        textOverflow: 'ellipsis',
                        overflow: 'hidden'
                    }}>{props.element.title}</div>

                    <span className="fa-layers fa-fw fa-lg" style={{display: props.showEmbeddingState ? 'block' : 'none'}}>
                        <FontAwesomeIcon icon={faSquare}
                                         color={props.element.embedded == true ? "#17813b" : props.element.embedded == false ? "#ccc" : "#faad14"}/>
                        <FontAwesomeIcon icon={faCode}
                                         className={"fa-inverse"}
                                         transform="shrink-8"/>
                    </span>
                    <FontAwesomeIcon
                        style={{
                            background: "#ffffff",
                            border: "1px solid #eee",
                            borderRadius: 20,
                            padding: 5,
                            aspectRatio: 1
                        }}
                        icon={props.expanded ? faAngleDown : faAngleRight}
                        onClick={(e) => {
                            props.onExpand?.(props.element)
                            e.stopPropagation()
                        }}/>
                </Flex>
            </Button>
            <Flex
                style={{marginLeft: 20}}
                vertical={true}
                gap={10}>
                {props.expanded
                    ? props.element.items?.length > 0
                        ? props.children
                        : <Button style={{textAlign: 'start'}} disabled={true} type={'text'}>
                            No lore item added yet
                        </Button>
                    : ''
                }
            </Flex></Flex>
    )
}